<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <base-button
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            size="sm"
            v-b-modal.modal-ajout
            >Ajouter</base-button
          >
        </div>
      </div>
    </div>

    <div>
      <base-table
        class="table align-items-center"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="tableData"
      >
        <template slot="columns">
          <th>Nom</th>

          <th>Email</th>

          <th>Télephone</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <td class="budget">{{ row.name }}</td>
          <td>{{ row.email }}</td>

          <td>{{ row.phonenumber }}</td>
          <td class="text-right" v-if="user.role == 'admin'">
            <base-dropdown class="dropdown" position="right">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <!-- <a
                  class="dropdown-item"
                  href="#"
                  v-if="user.role == 'admin'"
                  @click="
                    $router.push({
                      name: 'permissions',
                      params: { id: row.id },
                    })
                  "
                  >Gérer les permissions</a
                > -->
                <a
                  class="dropdown-item"
                  href="#"
                  @click="openPopup(row)"
                  v-b-modal.modal-center
                  >Modifier</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  v-if="row.role != 'admin'"
                  @click="openPopup(row)"
                  v-b-modal.modal-1
                  >Supprimer</a
                >
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>
    <div></div>

    <!--  <div class="card-footer d-flex justify-content-end"
         >
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        
      ></b-pagination>
    </div>-->
    <ModalUpdateUser
      ref="updateUserModal"
      @usersadd="usersadd"
    ></ModalUpdateUser>
    <ModalAjoutUser @usersadd="usersadd"></ModalAjoutUser>
    <ModalDeleteUser ref="deleteUserModal"></ModalDeleteUser>
  </div>
</template>
<script>
import modal from "@/components/Modal";
import ModalUpdateUser from "./ModalUpdateUser";
import ModalAjoutUser from "./ModalAjoutUser";
import ModalDeleteUser from "./ModalDeleteUser";
import { setToken, get } from "@/mixins/api";
export default {
  name: "UserTable",
  components: {
    modal,
    ModalUpdateUser,
    ModalAjoutUser,
    ModalDeleteUser,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      delete: false,
      modaladd: false,

      tableData: [
        {
          id: "",
          name: "",

          email: "",
          phonenumber: "",
        },
      ],
      data: {
        result: [],
        count: 0,
      },

      values: [],
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk",
    };
  },
  computed: {
    rows() {
      return this.data.count;
    },
  },

  methods: {
    // modalclose(){this.modaladd=false},
    usersadd(element) {
      console.log(element);
      const el = {
        name: element.name,
        email: element.email,
        phonenumber: element.phonenumber,
      };
      this.tableData.unshift(el);
      console.log(this.tableData);
    },

    getUsers() {
      get("users").then((response) => {
        this.tableData = response.data.data;
      });
    },

    openPopup(data) {
      this.$refs.deleteUserModal.getUser(data);
      this.$refs.updateUserModal.getUser(data);
    },
  },

  mounted() {
    //setToken(this.userToken);
    this.getUsers();
  },
  created() {},
};
</script>
<style>
</style>
